module.exports = __webpack_public_path__ + "img/Group 332.320ba7a8.png";